'use client';

import { Dialog, DialogContent } from '@tuic/web-compositions/shared/Dialog';
import {
  DashboardCard,
  DashboardCardProps,
} from '@tuic/web-compositions/shared/DashboardCard';
import { FC, useEffect, useState } from 'react';
import { useClientTranslation } from '@lib/i18n/client';
import { GetSlashCredentialsResponse } from '@lib/third-parties/get-slash.types';
import { useGetSlashInternet } from '../lib/use-get-slash-internet';
import { ConnectionStatusSymbol } from '../components/connection-status-symbol';
import { Locale } from '@tuic/i18n';
import {
  NetworkAccessType,
  useNetworkAccessType,
} from '@modules/get-slash-internet-card/lib/use-network-access-type';
import { getConnectionStatus } from '@modules/get-slash-internet-card/lib/utils';
import { InternetCardContent } from '@modules/get-slash-internet-card/components/internet-card-content';
import { InternetCardViewData } from '@modules/get-slash-internet-card/lib/internet-card-view-data';

type Props = {
  locale: Locale;
  dashboardCard?: DashboardCardProps;
  viewData: InternetCardViewData | null;
  getSlashCredentials: GetSlashCredentialsResponse;
  useDebugEndpoints?: boolean;
};

export const InternetCard: FC<Props> = props => {
  const {
    locale,
    dashboardCard,
    viewData,
    getSlashCredentials,
    useDebugEndpoints,
  } = props;

  const [open, setOpen] = useState(false);
  const [dialogTitle, setDialogTitle] = useState<string>('');
  const { t } = useClientTranslation();

  const getSlashInternet = useGetSlashInternet({
    credentials: getSlashCredentials?.credentials,
    useDebugEndpoints,
  });

  const networkAccessType = useNetworkAccessType({
    useDebugEndpoints,
  });

  const { refreshSession, session } = getSlashInternet;

  useEffect(() => {
    refreshSession();
  }, [refreshSession]);

  useEffect(() => {
    if (networkAccessType === NetworkAccessType.Ship) {
      refreshSession();
    }
  }, [networkAccessType, refreshSession]);

  return (
    <>
      <DashboardCard
        {...dashboardCard}
        asChild
        tag={
          <ConnectionStatusSymbol
            size="sm"
            status={getConnectionStatus(networkAccessType, session)}
          />
        }
      >
        <button onClick={() => setOpen(true)} />
      </DashboardCard>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent
          title={dialogTitle ?? t('Internet an Bord')}
          disableSpacing
        >
          <InternetCardContent
            locale={locale}
            viewData={viewData}
            getSlashCredentials={getSlashCredentials}
            getSlashInternet={getSlashInternet}
            networkAccessType={networkAccessType}
            useDebugEndpoints={useDebugEndpoints}
            onTitleChange={setDialogTitle}
          />
        </DialogContent>
      </Dialog>
    </>
  );
};
